import * as Sentry from "@sentry/browser";

// ReportNonRequiredError
// 予期される、あるいはすでに報告済みのエラーで、あらためて `reportAsyncError` などを呼ばなくてもよいことを示す。
export class ReportNonRequiredError extends Error {}

const shouldReport = (error: any) => {
  if (error instanceof ReportNonRequiredError) {
    return false;
  }
  if (error.response?.status === 401) {
    return false;
  }
  return true;
};

export const reportTtzkPortalRelatedError = (error: any) => {
  if (!shouldReport(error)) {
    return;
  }

  const wrappedError = new Error(
    `[ttzk-portal related] ${
      error instanceof Error ? error.message : JSON.stringify(error)
    }`,
  );

  if (process.env.REACT_APP_ENVIRONMENT === "local") {
    alert(wrappedError);
    console.log(wrappedError);
    return;
  }

  const extra =
    typeof error?.response?.data === "object"
      ? { responseBodyStr: JSON.stringify(error.response.data) }
      : undefined;
  Sentry.captureException(wrappedError, { extra });
};
